import { useEffect, useState, useRef, useMemo } from "react";
import { useNavigate } from "react-router-dom";
import axiosInstance from "../../config/apiInterceptor.config";
import BarLoader from "react-spinners/BarLoader";
import Footer from "../../components/footer/footer.component";
import IntlTelInput from "intl-tel-input/react/build/IntlTelInput.esm";
import { parsePhoneNumber } from "react-phone-number-input";
import { ExcentButton, ExcentCheckbox } from "./dataRequest.styles";
import {
  ExcentSubmitButton1,
  ExcentSubmitButton2,
} from "../activeProfiling/activeProfiling.styles";

export const DataRequest = () => {
  // General states
  const INTEGRATION_URI = process.env.REACT_APP_INTEGRATION_URI;
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const inputRef = useRef(null);
  let iti = null;
  // const searchParams = new URLSearchParams(location.search);

  // Form values
  const [operationSelected, setOperationSelected] = useState(null);
  const [name, setName] = useState("");
  const [surname, setSurname] = useState("");
  const [phonePrefix, setPhonePrefix] = useState(34);
  const [phoneNumber, setPhoneNumber] = useState("");
  const [email, setEmail] = useState("");
  const [privacyChecked, setPrivacyChecked] = useState(false);
  const [newsletterChecked, setNewsletterChecked] = useState(false);

  // API data
  const [clientData, setClientData] = useState({});
  const [requestData, setRequestData] = useState({});

  // Errors
  const [nameError, setNameError] = useState(false);
  const [surnameError, setSurnameError] = useState(false);
  const [phoneError, setPhoneError] = useState(false);
  const [emailError, setEmailError] = useState(false);
  const [optionError, setOptionError] = useState(false);
  const [privacyError, setPrivacyError] = useState(false);
  const [emailErrorMessage, setEmailErrorMessage] = useState("");
  const [waitingMessage, setWaitingMessage] = useState(false);
  const [iframeKey, setIframeKey] = useState("");
  const phoneRef = useRef(null);
  const [qaTesting, setqaTesting] = useState(false);

  const searchParams = useMemo(() => {
    return new URLSearchParams(window.location.search);
  }, []);

  // Build request body with params data
  useEffect(() => {
    setIframeKey(searchParams.get("key"));
    setqaTesting(searchParams.get("qa_testing"));
    const features = JSON.parse(searchParams.get("features"));
    setRequestData({
      address: searchParams.get("address"),
      lat: parseFloat(searchParams.get("lat")).toFixed(5),
      lon: parseFloat(searchParams.get("lon")).toFixed(5),
      block: parseInt(searchParams.get("block")),
      staircase: searchParams.get("staircase"),
      property_type: parseInt(searchParams.get("property_type")),
      area: parseInt(searchParams.get("area")),
      floor: parseInt(searchParams.get("floor")),
      boundary_id: parseInt(searchParams.get("boundary_id")),
      municipio: searchParams.get("municipio"),
      provincia: searchParams.get("provincia"),
      build_status: parseInt(searchParams.get("build_status")),
      rooms: parseInt(searchParams.get("rooms")),
      nbaths: parseInt(searchParams.get("nbaths")),
      cadastral_bi: searchParams.get("cadastral_bi"),
      postal_code: searchParams.get("postal_code"),
      ...features,
    });
  }, [searchParams]);

  // Send info to out of frame and go to success page
  const send = async () => {
    setIsLoading(true);
    setTimeout(() => {
      setWaitingMessage(true);
    }, 4000);
    const parentWindow = window.parent;
    await axiosInstance
      .post(`${INTEGRATION_URI}valuation`, requestData, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${iframeKey}`,
        },
      })
      .then((response) => {
        if (response.status !== 200) {
          console.error(response);
          return;
        }
        if (response.status === 200) {
          const responseMessage = {
            valuation_uid: response.data.uid,
            valuation_link: `https://calculator-pro-pzgnkcicxq-ew.a.run.app/modalUDA?key=${iframeKey}&valuation_uid=${response.data.uid}`,
            ...clientData,
          };
          parentWindow.postMessage(responseMessage, "*");
          setIsLoading(false);
          navigate(
            `/successScreen?key=${iframeKey}&valuation_uid=${responseMessage.valuation_uid.toString()}${
              qaTesting ? "&qa_testing=true" : ""
            }`,
            { replace: true }
          );
          return window.location.reload();
        }
        setIsLoading(false);
        setWaitingMessage(false);
      });
  };

  // Go back
  const back = () => {
    navigate(
      `/active?key=${iframeKey}&${new URLSearchParams(requestData).toString()}`
    );
    return window.location.reload();
  };

  const handleOperation = (option) => {
    setOperationSelected(option === operationSelected ? null : option);
    const updatedRequest = {
      ...requestData,
      operation:
        operationSelected === "buy" ? 0 : operationSelected === "sell" ? 1 : 2,
    };
    setRequestData(updatedRequest);
    setOptionError(false);
  };

  const handlePrivacyCheckbox = () => {
    setPrivacyChecked(!privacyChecked);
    setPrivacyError(false); // Limpiar el mensaje de error al marcar/desmarcar la casilla
  };

  const handleNewsletterCheckbox = (option) => {
    setNewsletterChecked(option === newsletterChecked ? null : option);
  };

  const validateOperationSelected = () => {
    if (!operationSelected) {
      setOptionError(true);
      return false;
    }
    return true;
  };

  const validateName = () => {
    if (name === "") {
      setNameError(name === "");
      return false;
    }
    return true;
  };

  const validateSurname = () => {
    if (surname === "") {
      setSurnameError(surname === "");
      return false;
    }
    return true;
  };

  const validatePhone = () => {
    console.log(phoneNumber, phonePrefix);
    if (
      phoneNumber === undefined ||
      phoneNumber === "" ||
      phonePrefix === undefined ||
      phonePrefix === ""
    ) {
      setPhoneError(true);
      return false;
    } else {
      setPhoneError(false);
      return true;
    }
  };

  const validateEmail = () => {
    const emailRegex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;
    if (!emailRegex.test(email)) {
      setEmailError(true);
      setEmailErrorMessage("Por favor, introduce un email válido.");
      return false;
    } else if (email === "") {
      setEmailError(true);
      setEmailErrorMessage(
        "Escribe una dirección de correo electrónico para continuar."
      );
      return false;
    } else {
      setEmailError(false);
    }
    return true;
  };

  const validateClientData = () => {
    const nameValidated = validateName();
    const surnameValidated = validateSurname();
    const phoneValidated = validatePhone();
    const emailValidated = validateEmail();
    if (
      !nameValidated ||
      !surnameValidated ||
      !phoneValidated ||
      !emailValidated
    ) {
      return false;
    }
    return true;
  };

  const validatePrivacyChecked = () => {
    if (privacyChecked !== true) {
      setPrivacyError(true);
      return false;
    }
    return true;
  };

  const handleValidation = () => {
    const operationSelectionValidation = validateOperationSelected();
    const clientDataValidation = validateClientData();
    const phoneValidation = validatePhone();
    const emailValidation = validateEmail();
    const privacyValidation = validatePrivacyChecked();
    // Check if any of the inputs are false
    if (
      !operationSelectionValidation ||
      !clientDataValidation ||
      !phoneValidation ||
      !emailValidation ||
      !privacyValidation
    ) {
      return false;
    }
    return true;
  };

  const handleSubmit = () => {
    const validation = handleValidation();
    if (!validation) {
      return;
    }
    send();
  };

  const handleScrollToInput = () => {
    inputRef.current.scrollIntoView({
      behavior: "smooth", // You can use 'smooth', 'auto' or 'instant'
      block: "center", // You can use 'start, 'center' or 'end'
      inline: "center", // You can use 'start, 'center' or 'end'
    });
  };

  useEffect(() => {
    setClientData({
      name: name,
      surname: surname,
      phone_prefix: phonePrefix,
      phone_number: phoneNumber,
      email: email,
      operation_type: operationSelected === "buy" ? "buy" : operationSelected === "sell" ? "sell" : "other",
      terms_accepted: privacyChecked ? true : null,
      newsletter_subscription: newsletterChecked ? true : false,
      postal_code: requestData.postal_code,
      municipio: requestData.municipio,
      provincia: requestData.provincia,
    });
  }, [
    name,
    surname,
    phoneNumber,
    phonePrefix,
    email,
    operationSelected,
    privacyChecked,
    newsletterChecked,
    requestData,
  ]);

  useEffect(() => {
    if (optionError === true) {
      window.scrollTo(0, 220);
    }
  }, [optionError]);

  useEffect(() => {
    if ((nameError || emailError || surnameError) && !optionError) {
      window.scrollTo(0, 450);
    }
  }, [nameError, optionError, surnameError, emailError]);

  return (
    <main className="flex w-full flex-col justify-center items-center font-roboto parent-container">
      <form className="w-full desktop:w-1/2">
        <div className="flex justify-center">
          <div className="flex justify-center flex-col tablet:w-1/2 desktop:w-full w-full tablet:px-0 px-5">
            <h1 className="text-4xl">
              <strong>¡Ya casi está!</strong>
            </h1>
            <h2>
              Recibirás los resultados por correo electrónico y tus datos solo
              se utilizarán para enviarte la información solicitada.
            </h2>
            <p style={{ color: "red" }}>* Campos obligatorios</p>
          </div>
        </div>

        <div className="flex justify-center">
          <div className="tablet:w-1/2 desktop:w-full w-full tablet:px-0 px-5">
            <div className="py-6 space-y-5">
              <div className="space-y-3">
                <p style={{ maxInlineSize: "90%" }}>
                  <strong>
                    ¿Para qué estás valorando este inmueble?
                    <span style={{ color: "red" }}>*</span>
                  </strong>
                </p>
                <div className="flex flex-col pb-3">
                  <div className="flex flex-wrap items-center">
                    {/* Button To buy */}
                    <label className="mr-3 pt-2">
                      <input
                        type="radio"
                        name="option"
                        className="hidden"
                        checked={operationSelected === "buy"}
                        onChange={() => handleOperation("buy")}
                      />
                      <ExcentButton
                        checked={operationSelected === "buy"}
                        onClick={() => handleOperation("buy")}
                      >
                        Para comprar
                      </ExcentButton>
                    </label>

                    {/* Button To sell */}
                    <label className="mr-3 pt-2">
                      <input
                        type="radio"
                        name="option"
                        className="hidden"
                        checked={operationSelected === "sell"}
                        onChange={() => handleOperation("sell")}
                      />
                      <ExcentButton
                        onClick={() => handleOperation("sell")}
                        checked={operationSelected === "sell"}
                      >
                        Para vender
                      </ExcentButton>
                    </label>
                    {/* Button For Other */}
                    <label className="mr-3 pt-2">
                      <input
                        type="radio"
                        name="option"
                        className="hidden"
                        checked={operationSelected === "other"}
                        onChange={() => handleOperation("other")}
                      />
                      <ExcentButton
                        onClick={() => handleOperation("other")}
                        checked={operationSelected === "other"}
                      >
                        Otro motivo
                      </ExcentButton>
                    </label>
                  </div>
                  {optionError && (
                    <p className="text-[#DE0E48] pt-3 ">
                      Selecciona una opción para continuar.
                    </p>
                  )}
                </div>
              </div>

              <div className="flex flex-col space-y-3">
                <p>
                  <strong>Datos personales</strong>
                </p>
                <div className="flex flex-col">
                  <label
                    style={{
                      display: "flex",
                      flexDirection: "row",
                    }}
                  >
                    Nombre<p style={{ color: "red" }}>*</p>
                  </label>
                  <input
                    type="text"
                    className={`data-request-inputs${
                      nameError ? " input-error" : ""
                    }`}
                    value={name}
                    ref={inputRef}
                    onChange={(e) => {
                      setNameError(false);
                      setName(e.target.value);
                    }}
                    id="nameInput"
                    onFocus={() => {
                      setNameError(false);
                      handleScrollToInput();
                    }}
                    onBlur={() => validateName()}
                  />
                </div>
                <div className="flex flex-col">
                  <label
                    style={{
                      display: "flex",
                      flexDirection: "row",
                    }}
                  >
                    Apellidos
                    <p style={{ color: "red" }}>*</p>
                  </label>
                  <input
                    type="text"
                    className={`data-request-inputs${
                      surnameError ? " input-error" : ""
                    }`}
                    value={surname}
                    ref={inputRef}
                    onChange={(e) => {
                      setSurnameError(false);
                      setSurname(e.target.value);
                    }}
                    id="surnameInput"
                    onFocus={() => {
                      setSurnameError(false);
                      handleScrollToInput();
                    }}
                    onBlur={() => validateSurname()}
                  />
                </div>
                {nameError && (
                  <p className="text-[#DE0E48] pt-1">{nameError}</p>
                )}
                <div className="phone-email-wrapper">
                  <div className="flex flex-col">
                    <label
                      style={{
                        display: "flex",
                        flexDirection: "row",
                      }}
                    >
                      Teléfono
                      <p style={{ color: "red" }}>*</p>
                    </label>

                    <IntlTelInput
                      initialValue={phoneNumber}
                      onChangeNumber={(e) => {
                        const number = e.toString();
                        const parsed = parsePhoneNumber(e.toString());
                        if (parsed) {
                          setPhonePrefix(`+${parsed.countryCallingCode}`);
                          if (
                            number
                              .toString()
                              .includes(`+${parsed.countryCallingCode}`)
                          ) {
                            const updatedPhoneNumber = number.replace(
                              `+${parsed.countryCallingCode}`,
                              ""
                            );
                            setPhoneNumber(updatedPhoneNumber);
                            setPhoneError(false);
                          }
                        } else {
                          setPhonePrefix(undefined);
                        }
                      }}
                      value={phoneNumber}
                      onBlur={() => validatePhone()}
                      initOptions={{
                        initialCountry: "es",
                        utilsScript:
                          "/intl-tel-input/js/utils.js?1706723638591",
                        formatAsYouType: true,
                        formatOnDisplay: true,
                        showSelectedDialCode: true,
                        preferredCountries: ["es"],
                        autoInsertDialCode: true,
                      }}
                    />
                    {phoneError && (
                      <p className="text-[#DE0E48] pt-1">
                        Por favor, introduce un número válido
                      </p>
                    )}
                  </div>
                  <div className="flex flex-col">
                    <label
                      style={{
                        display: "flex",
                        flexDirection: "row",
                      }}
                    >
                      Email
                      <p style={{ color: "red" }}>*</p>
                    </label>
                    <input
                      type="email"
                      className={`data-request-inputs${
                        emailError ? " input-error" : ""
                      }`}
                      value={email}
                      ref={inputRef}
                      onChange={(e) => setEmail(e.target.value)}
                      onBlur={() => validateEmail()}
                      onFocus={() => {
                        handleScrollToInput();
                      }}
                      id="emailInput"
                    />
                    {emailError && (
                      <p className="text-[#DE0E48] pt-1">{emailErrorMessage}</p>
                    )}
                  </div>
                </div>
              </div>

              <div className="space-y-2 py-3">
                <div className="flex items-center space-x-2">
                  <ExcentCheckbox
                    type="checkbox"
                    id="checkbox1"
                    onChange={() => handlePrivacyCheckbox()}
                  />
                  <label className="block">
                    <p className="inline">Acepto la{"\u00A0"}</p>
                    <a
                      href="https://www.alisedainmobiliaria.com/sobre-aliseda/politica-de-privacidad"
                      rel="noreferrer"
                      target="_blank"
                      className="inline font-bold"
                    >
                      Política de Privacidad y protección de Datos
                      <span style={{ color: "red" }}>*</span>
                    </a>
                  </label>
                </div>
                {privacyError && (
                  <p className="flex items-start text-[#DE0E48]">
                    Si estás de acuerdo con nuestra política, debes seleccionar
                    la opción.
                  </p>
                )}
                <div className="flex items-center space-x-2">
                  <ExcentCheckbox
                    type="checkbox"
                    id="checkbox2"
                    onChange={() => handleNewsletterCheckbox("select")}
                  />
                  <label className="block" htmlFor="checkbox2">
                    Recibir <strong>más información</strong> sobre los servicios
                    de venta o compra
                  </label>
                </div>
              </div>
            </div>

            <div className="flex tablet:flex-row flex-col items-center justify-center w-full tablet:space-x-6 space-x-0 tablet:space-y-0 space-y-4">
              <ExcentSubmitButton1 type="button" onClick={back} width="300">
                Atrás
              </ExcentSubmitButton1>
              <ExcentSubmitButton2 type="button" onClick={handleSubmit}>
                <p className="text-white">Enviar</p>
              </ExcentSubmitButton2>
            </div>
            {isLoading && (
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  alignItems: "center",
                  paddingTop: "20px",
                  rowGap: "20px",
                }}
              >
                <BarLoader
                  color={"#262626"}
                  loading={isLoading}
                  cssOverride={{ width: "90%" }}
                  size={100}
                  aria-label="Loading spinner"
                />
                {waitingMessage && (
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      paddingTop: "20px",
                    }}
                  >
                    Disculpa, esto podría tardar unos segundos...
                  </div>
                )}
              </div>
            )}
          </div>
        </div>
        <div style={{ paddingTop: "2em" }}></div>
      </form>
      <Footer />
    </main>
  );
};

export default DataRequest;
